module.exports = __webpack_public_path__ + "img/sichtschutz1.86139a14.png";